import gql from "graphql-tag";
import { UserFragment } from "./fragments";
import { createBoundMutation } from "./util";

const subscribe = gql`
  mutation subscribe($nonce: String) {
    subscribe(nonce: $nonce) {
      ...UserFragment
    }
  }
  ${UserFragment}
`;

const subscribeWithCode = gql`
  mutation subscribeByCodeByCode($code: String){
    subscribeByCode(code:$code){
      ...UserFragment,
    }
  }
  ${UserFragment}
`;

export namespace subscriptionMutations {
  interface SubscribeArgs {
    nonce: string;
  }

  export const Subscribe = createBoundMutation<any, SubscribeArgs>({
    mutation: subscribe
  });

  export interface SubscribeWithCodeArgs{
    code: string;
  }
  export const SubscribeWithCode = createBoundMutation<any, SubscribeWithCodeArgs>({
    mutation: subscribeWithCode
  });

}


// WEBPACK FOOTER //
// ./src/api/subscription.ts